(function () {
  const FORM_PATH = '/pages/formulaire-projet-tatouage';
  const TALLY_ORIGIN = 'https://tally.so';
  const TALLY_FORM_ID = 'RGj58l';

  function sendEvent(name, parameters) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, parameters || {});
  }

  function ctaLocation(link) {
    if (link.closest('header')) return 'header';
    if (link.closest('footer')) return 'footer';
    return 'content';
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (_error) {
      return;
    }

    if (url.origin === window.location.origin && url.pathname === FORM_PATH) {
      sendEvent('project_cta_click', {
        cta_location: ctaLocation(link),
        destination: FORM_PATH
      });
    }
  });

  if (window.location.pathname === FORM_PATH) {
    sendEvent('project_form_view', { form_id: TALLY_FORM_ID });
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== TALLY_ORIGIN || typeof event.data !== 'string') return;
    if (!event.data.includes('Tally.FormSubmitted')) return;

    let message;
    try {
      message = JSON.parse(event.data);
    } catch (_error) {
      return;
    }

    if (message.payload?.formId !== TALLY_FORM_ID) return;

    const storageKey = 'joanna_project_lead_' + TALLY_FORM_ID;
    try {
      if (window.sessionStorage.getItem(storageKey)) return;
      window.sessionStorage.setItem(storageKey, '1');
    } catch (_error) {
      // The event remains measurable when storage is unavailable.
    }

    sendEvent('generate_lead', {
      method: 'tally',
      form_id: TALLY_FORM_ID,
      lead_type: 'tattoo_project'
    });
  });
})();
